module.exports = __webpack_public_path__ + "static/media/stakeholdermapping.bb1c87dd.pdf";